// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:-AKrlz */\n.DAohu{display:flex;flex-direction:column-reverse;gap:var(--audio-spacing-24);width:100%}.sAGGi{width:100%}.I8iMD{display:flex;flex-direction:column;gap:var(--audio-spacing-48);width:100%}.enXj9{min-width:0;width:100%}@media (min-width:1280px){.DAohu{flex-direction:row;gap:var(--audio-spacing-64);margin:0 auto;max-width:var(--audio-layout-xl)}.sAGGi{flex-shrink:0;width:19.5rem}.enXj9{flex:1 1 0%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": "DAohu",
	"sidebar": "sAGGi",
	"suggestions": "I8iMD",
	"content": "enXj9"
};
export default ___CSS_LOADER_EXPORT___;
